import api from "./api";

function toQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.set(key, String(value));
    }
  });
  return query.toString();
}

export async function listSupplierInvoices(filters = {}) {
  const query = toQuery(filters);
  const res = await api.get(`/supplier-invoices${query ? `?${query}` : ""}`);
  return res.data;
}

export async function getSupplierInvoice(id) {
  const res = await api.get(`/supplier-invoices/${id}`);
  return res.data;
}

export async function createSupplierInvoice(payload) {
  const res = await api.post("/supplier-invoices", payload);
  return res.data;
}

export async function updateSupplierInvoice(id, payload) {
  const res = await api.patch(`/supplier-invoices/${id}`, payload);
  return res.data;
}

export async function recomputeSupplierInvoiceDifferences(id, payload = {}) {
  const res = await api.post(`/supplier-invoices/${id}/recompute-differences`, payload);
  return res.data;
}

export async function matchSupplierInvoiceLines(id, payload) {
  const res = await api.post(`/supplier-invoices/${id}/match-lines`, payload);
  return res.data;
}

export async function approveSupplierInvoice(id, payload = {}) {
  const res = await api.post(`/supplier-invoices/${id}/approve`, payload);
  return res.data;
}

export async function rejectSupplierInvoice(id, payload) {
  const res = await api.post(`/supplier-invoices/${id}/reject`, payload);
  return res.data;
}
